import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CHAPTERS, ASSETS } from "@/lib/pnp";
import { Rise, RevealWords } from "./Reveal";

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="ueber-uns"
      data-testid="manifesto-section"
      ref={ref}
      className="relative bg-white py-24 md:py-40 overflow-hidden"
    >
      <div className="px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
          <div className="col-span-12 md:col-span-4">
            <div className="font-mono-pp text-[11px] uppercase tracking-[0.24em] text-[#4F6858] mb-6">
              Über uns · Manifest
            </div>
            <h2
              className="font-display font-extrabold text-[#082E19] leading-[0.92] tracking-tighter"
              style={{ fontSize: "clamp(2.25rem, 5vw, 4rem)" }}
            >
              <RevealWords text="Drei Prinzipien, ein Ansatz." />
            </h2>

            {/* Flyer / Owners */}
            <div className="mt-10 md:mt-14 relative overflow-hidden rounded-md ring-1 ring-[#DFEBE4] bg-[#F4F7F5] aspect-[3/4]">
              <motion.img
                src={ASSETS.flyerOwners}
                alt="Der originale P&P Gartenservice Flyer"
                style={{ y: imgY }}
                className="absolute inset-0 h-[110%] w-full object-contain"
              />
              <div className="absolute left-4 bottom-4 right-4 flex items-end justify-between text-[#082E19]">
                <div>
                  <div className="font-mono-pp text-[10px] uppercase tracking-[0.22em] opacity-70">Der Gründer</div>
                  <div className="font-display font-semibold text-lg leading-tight mt-1">Jung. Motiviert. Einsatzbereit.</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <ul className="divide-y divide-[#DFEBE4] border-t border-[#DFEBE4]">
              {CHAPTERS.map((c, i) => (
                <li key={c.n}>
                  <Rise delay={i * 0.05}>
                    <div className="grid grid-cols-12 gap-4 py-10 md:py-14 items-start">
                      <div className="col-span-2 md:col-span-2">
                        <div className="pp-numeral text-[#17C964]" style={{ fontSize: "clamp(3rem, 6vw, 5rem)" }}>
                          {c.n}
                        </div>
                      </div>
                      <div className="col-span-10 md:col-span-10">
                        <h3
                          className="font-display font-bold text-[#082E19] tracking-tight"
                          style={{ fontSize: "clamp(1.75rem, 3.4vw, 2.75rem)" }}
                        >
                          {c.title}
                        </h3>
                        <p className="mt-4 text-[#4F6858] max-w-xl leading-relaxed text-[15px] md:text-base">
                          {c.body}
                        </p>
                      </div>
                    </div>
                  </Rise>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
